<mat-card>
  <mat-card-header>
    <mat-card-title>AVAILABILITY</mat-card-title>
    @if (editable()) {
      <button class="usa-button usa-button--secondary" (click)="edit()" style="min-width: 70px;" aria-label="Edit Availability">
        <fa-icon [icon]="faEdit" style="color: #216E1F;"></fa-icon>&nbsp;Edit
      </button>
    }
  </mat-card-header>
  @if (user()) {
    <mat-card-content>
      <div class="outer_div">
        <div class="inner_div">
          <div class="data-div">
            <p class="data-title">Availability</p>
            <div class="available-list">
              @if (user().available_local) {
                <mat-chip>Available Locally</mat-chip>
              }
              @if (user().available_region) {
                <mat-chip>Available Regionally</mat-chip>
              }
              @if (user().available_nation) {
                <mat-chip>Available Nationally</mat-chip>
              }
              @if (!user().available_local && !user().available_region && !user().available_nation) {
                <p>--</p>
              }
            </div>
          </div>
          <div class="data-div">
            <div class="data-title">Conflict dates <div class="data-subtitle">(Known unavailable dates)</div>
          </div>
          <p class="data-info">{{user().conflict_dates || '--'}}</p>
        </div>
      </div>
    </div>
  </mat-card-content>
}
</mat-card>